import { axios,axios2 } from '@/lib/axios';

export const changeAllFav = (id: string, type: string) => {
  const payload = {
    id: id,
    type: type,
  };
  return axios2.post('/customer-api/remove-favourite', payload);
};
